import '@/app/app.css';
import './main.css';

import '@/app/app';
import '@/layouts/main/main';

import {MainBanner} from '@/features/main-page/main-banner/main-banner';
import {ProductBlock} from '@/features/product-block/product-block';
import {SliderProducts} from '@/features/slider-products/slider-products';
import {MainPopular} from '@/features/main-page/main-popular/main-popular';

window.app.ProductBlock = ProductBlock;
window.app.SliderProducts = SliderProducts;

window.addEventListener('DOMContentLoaded', () => {
	new MainBanner(document.querySelector('.main-banner'));

	document.querySelectorAll('.product-block').forEach((element) => new ProductBlock(element));
	document.querySelectorAll('.js-slider-products').forEach((slider) => new SliderProducts(slider));
	new MainPopular(document.querySelector('.js-main-popular'));
});
